import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    selectPaymentOption: 'Select your payment option',
    selectSellFor: 'Select what to sell for',
    selectWhatBuy: 'Select what to buy',
    selectWhatSell: 'Select what to sell',
    all: 'All',
    mostPopular: 'Most Popular',
    commodities: 'Commodities',
    holdings: 'Holdings',
    valueBalance: 'Value/Balance',
    noAsset: 'You don’t hold an asset that can be traded with',
    noBalance: 'No available balance',
    chooseAssetToDeposit: 'Choose an asset to make a deposit.',
    insufficientBalance: 'Insufficient balance',
    insufficientBalanceToTrade: (productCode: string) =>
      `Insufficient balance to trade with ${productCode}`,
    cannotBeTraded: (fromProductCode: string, toProductCode: string) =>
      `${fromProductCode} cannot be traded with ${toProductCode}`,
    leastBalanceToTransact: (amount: string) =>
      `An asset balance of at least ${amount} is required to transact.`,
    showingResults: 'Showing results for',
    crypto: 'Crypto',
    cryptoBundles: 'Crypto Bundles',
    stocks: 'Stocks',
    stableCoin: 'Stablecoin',
  },
  de: {
    selectPaymentOption: 'Wähle deine Bezahlmethode aus',
    selectSellFor: 'Wähle, für was du verkaufen möchtest',
    selectWhatBuy: 'Wähle, was du kaufen möchtest',
    selectWhatSell: 'Wähle, was du verkaufen möchtest',
    all: 'Alle',
    mostPopular: 'Am beliebtesten',
    commodities: 'Rohstoffe',
    holdings: 'Guthaben',
    valueBalance: 'Wert/Saldo',
    chooseAssetToDeposit: 'Wähle ein Asset zum Einzahlen aus.',
    noAsset: 'Du besitzt kein Asset das zum Traden verwendet werden kann',
    noBalance: 'Kein verfügbares Guthaben',
    insufficientBalance: 'Verfügbares Guthaben unausreichend',
    insufficientBalanceToTrade: (productCode: string) =>
      `Unzureichendes Guthaben zum Handel mit ${productCode}`,
    cannotBeTraded: (fromProductCode: string, toProductCode: string) =>
      `${fromProductCode} kann nicht mit ${toProductCode} gehandelt werden`,
    leastBalanceToTransact: (amount: string) =>
      `Ein Guthaben von mindestens ${amount} ist zum Traden notwendig.`,
    showingResults: 'Ergebnisse für',
    crypto: 'Krypto',
    cryptoBundles: 'Krypto-Bundles',
    stocks: 'Aktien',
    stableCoin: 'Stablecoin',
  },
});
